export default "__VITE_ASSET__DpTGlLAM__"